import { Textarea } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldTextareaProps {
    field: FormFieldDto;
}

export function FormFieldTextarea({ field }: FormFieldTextareaProps) {
    const minLength = field.validation?.find((v) => v.type === 'minLength')?.value;
    const maxLength = field.validation?.find((v) => v.type === 'maxLength')?.value;

    return (
        <Textarea
            name={field.name}
            className="form-input"
            rows={3}
            required={field.required}
            placeholder={field.options?.placeholder}
            defaultValue={field.options?.defaultValue}
            minLength={minLength ? parseInt(minLength) : undefined}
            maxLength={maxLength ? parseInt(maxLength) : undefined}
        />
    );
}
